<!-- TOGGLE, SHARE, PRINT DOWNLOAD TEMPLATES-->
<section>
  <section
    *ngIf="
      platformService.platformType === platformService.platformEnum.tablet ||
      platformService.platformType === platformService.platformEnum.desktop
    "
  >
    <ng-container
      *ngTemplateOutlet="pdpSummaryTabsDesktopTablet"
    ></ng-container>
  </section>
  <section
    *ngIf="platformService.platformType === platformService.platformEnum.mobile"
  >
    <ng-container *ngTemplateOutlet="pdpSummaryTabsMobile"></ng-container>
  </section>
</section>

<ion-row
  class="pdp-summary-info"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <!-- Product Images -->
  <ion-col
    size-xl="5.75"
    size-lg="5.75"
    size-md="5.75"
    size-sm="12"
    size-xs="12"
  >
    <app-product-detail-viewer
      *ngIf="currentTab === 1"
      appTestId="pdp-summary-image-viewer"
      [product]="product?.summary"
      [showNoImageDescription]="true"
      (emitterFromPDPViewer)="openCarouselImagesModal($event)"
    ></app-product-detail-viewer>
    <app-product-detail-seller-image
      *ngIf="currentTab === 2"
      appTestId="pdp-summary-seller-image"
      [product]="product?.summary"
    ></app-product-detail-seller-image>
  </ion-col>
  <!-- Product Info -->
  <ion-col
    size-xl="5.75"
    size-lg="5.75"
    size-md="5.75"
    size-sm="12"
    size-xs="12"
    offset-xl="0.5"
    offset-lg="0.5"
    offset-md="0.5"
  >
    <div data-cy="pdp-summary-info-section" class="pdp-summary-info-section">
      <!-- Ratings -->
      <ng-container *ngIf="currentTab === 1">
        <div data-cy="pdp-summary-ratings-section" class="pdp-summary-ratings">
          <app-power-reviews-snippet
            *appShowSplit="[productReviewsFeatureFlag]"
            appTestId="pdp-summary-power-reviews"
            [productNumber]="product?.productNumber"
            (trackRatingandReview)="trackRatingandReview()"
          ></app-power-reviews-snippet>
        </div>
      </ng-container>
      <!-- Brand -->
      <div
        (click)="searchBrand(product?.summary?.brand)"
        data-cy="pdp-summary-brand-text"
        class="pdp-summary-brand-text brand-link"
        *appShowSplit="[moreFromThisBrandFlag]"
      >
        {{ product?.summary?.brand | acronymTitleCase }}
      </div>
      <div
        data-cy="pdp-summary-brand-text"
        class="pdp-summary-brand-text"
        *appHideSplit="[moreFromThisBrandFlag]"
      >
        {{ product?.summary?.brand | acronymTitleCase }}
      </div>
      <!-- Description -->
      <div data-cy="pdp-summary-desc-text" class="pdp-summary-desc-text">
        {{
          product?.summary?.productDescTxtl ||
            productDescriptionNotAvailableMessage | translate
        }}
      </div>
    </div>

    <div
      *ngIf="currentTab === 1"
      data-cy="pdp-summary-overview-card"
      class="pdp-summary-info-section pdp-summary-overview-card"
    >
      <!-- Alert Message -->
      <div
        *ngIf="alertMessage?.display && !isGuestUser"
        data-cy="psp-summary-alert-message-section"
        class="pdp-summary-alert-message-container"
      >
        <app-product-message-banner
          [alertMessage]="alertMessage"
        ></app-product-message-banner>
      </div>
      <!-- Promotions Message -->
      <div
        *ngIf="product?.promotionDetails?.offerBenefitDesc && !isGuestUser"
        data-cy="pdp-summary-promotions-section"
        class="pdp-summary-banner-container usf-product-card-promotions"
        (click)="clickPromotions($event)"
      >
        <span data-cy="pdp-summary-promotions-text">
          {{ product?.promotionDetails?.offerBenefitDesc }}
        </span>
      </div>
      <!-- Catch Weight Message -->
      <div
        *ngIf="product?.summary?.catchWeightFlag && !isGuestUser"
        data-cy="pdp-summary-catch-weight-section"
        class="pdp-summary-banner-container pdp-summary-catch-weight-container"
      >
        <ion-icon
          data-cy="pdp-summary-catch-weight-icon"
          name="information-circle-outline"
        ></ion-icon>

        <span data-cy="pdp-summary-catch-weight-text">
          <span
            data-cy="pdp-summary-catch-weight-note-text"
            class="catch-weight-note"
            >{{ 'i18n.common.note' | translate }}</span
          >
          {{ 'i18n.productDetail.catchWeight' | translate }}</span
        >
      </div>
      <!-- Quantities -->
      <div
        data-cy="pdp-summary-quantities"
        class="pdp-summary-quantity-info-container"
        *ngIf="!isGuestUser"
      >
        <div
          data-cy="pdp-summary-cases-section"
          class="quantity-info-column"
          [class.separate-shipping]="isProductShippingPriceEnabled$ | async"
        >
          <div class="price-row">
            <app-price-display
              *ngIf="
                !product?.summary?.properties?.has(propertiesEnum.specialOrder)
              "
              class="price-text"
              [disabled]="pricingDisabled"
              [price]="product?.pricing"
              [displayCases]="true"
              [catchWeightFlag]="product?.summary?.catchWeightFlag"
              [priceUom]="product?.summary?.priceUom"
              [id]="'pdp-cases-price-display-' + product?.productNumber"
            ></app-price-display>
          </div>
          <app-product-shipping-price
            *ngIf="
              !product?.summary?.properties?.has(propertiesEnum.specialOrder) &&
              product?.summary?.properties?.has(propertiesEnum.direct) &&
              (isProductShippingPriceEnabled$ | async)
            "
            [pricing]="product?.pricing"
            [disabled]="pricingDisabled"
          ></app-product-shipping-price>
          <div class="price-row quantity-input">
            <app-quantity-input
              [productNumber]="product?.summary?.productNumber"
              [isDisabled]="quantityBoxesDisabledStatus"
              [isEaches]="false"
              [platform]="platformService?.platformType"
              [quantity]="orderItem?.unitsOrdered"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
            ></app-quantity-input>
          </div>
          <app-product-inventory-info
            *ngIf="displayInventory && product?.summary?.properties"
            [productInventory]="product?.inventory"
            [productProperties]="product?.summary?.properties"
            [productSummary]="product?.summary"
            [hideOutOfStock]="product?.hideOutOfStock"
            [id]="'pdp-cases-inventory-display-' + product?.productNumber"
          ></app-product-inventory-info>
        </div>
        <div
          *ngIf="product?.summary?.breakable"
          data-cy="pdp-summary-eaches-section"
          class="quantity-info-column"
        >
          <div class="price-row">
            <app-price-display
              *ngIf="
                !product?.summary?.properties?.has(propertiesEnum.specialOrder)
              "
              class="price-text"
              [disabled]="pricingDisabled"
              [price]="product?.pricing"
              [catchWeightFlag]="product?.summary?.catchWeightFlag"
              [displayCases]="false"
              [eachUom]="
                product?.summary?.catchWeightFlag
                  ? product?.summary?.priceUom
                  : product?.summary?.eachUom
              "
              [id]="'pdp-eaches-price-display-' + product?.productNumber"
            ></app-price-display>
          </div>
          <div class="price-row">
            <app-quantity-input
              [productNumber]="product?.summary?.productNumber"
              [isDisabled]="quantityBoxesDisabledStatus"
              [isEaches]="true"
              [platform]="platformService?.platformType"
              [quantity]="orderItem?.eachesOrdered"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
            ></app-quantity-input>
          </div>
          <app-product-inventory-info
            *ngIf="displayInventory && product?.summary?.properties"
            [productInventory]="product?.inventory"
            [productProperties]="product?.summary?.properties"
            [productSummary]="product?.summary"
            [hideOutOfStock]="product?.hideOutOfStock"
            eaches
            [id]="'pdp-eaches-inventory-display-' + product?.productNumber"
          ></app-product-inventory-info>
        </div>
      </div>
      <!-- Product Numbers, Sales Pack Size, Cost Breakdown -->
      <div
        data-cy="pdp-summary-other-info"
        class="pdp-summary-other-info-container"
      >
        <p
          data-cy="pdp-summary-product-number-text"
          [class.not-found]="product?.notFound"
        >
          #{{ product?.productNumber || ' ' }}
        </p>
        <ng-container *ngIf="!product?.notFound">
          <ng-container *ngIf="customerProductNumber">
            <div
              data-cy="pdp-summary-separator-line"
              class="other-info-separator"
            ></div>
            <p
              data-cy="pdp-summary-customer-product-number-text"
              [id]="'pdp-customer-product-number-' + product?.productNumber"
            >
              {{ customerProductNumber }}
            </p>
          </ng-container>
          <ng-container *ngIf="product?.summary?.salesPackSize">
            <div
              data-cy="pdp-summary-separator-line"
              class="other-info-separator"
            ></div>
            <p data-cy="pdp-summary-sales-pack-size-text">
              {{ product?.summary?.salesPackSize }}
            </p>
          </ng-container>
          <ng-container *ngIf="product?.costBreakdown">
            <div
              data-cy="pdp-summary-separator-line"
              class="other-info-separator"
            ></div>
            <p data-cy="pdp-summary-cost-breakdown-text">
              {{ product?.costBreakdown }}
            </p>
          </ng-container>
        </ng-container>
      </div>
      <!-- Divider -->
      <div
        *ngIf="
          jitVendorMessage.showMessage ||
          product?.summary?.properties?.has(propertiesEnum.ces) ||
          displayTags?.length > 0
        "
        data-cy="pdp-summary-divider-line"
        class="horizontal-divider"
      ></div>
      <!-- Inventory Info -->
      <app-product-inventory-info
        *ngIf="
          displayInventory &&
          product?.summary?.properties &&
          product?.summary?.properties?.has(propertiesEnum.outOfStock)
        "
        class="pdp-summary-expected-restock"
        [productInventory]="product?.inventory"
        [productProperties]="product?.summary?.properties"
        [productSummary]="product?.summary"
        [hideOutOfStock]="product?.hideOutOfStock"
        [isRestock]="isRestock"
      ></app-product-inventory-info>
      <ng-container *ngIf="shouldDisplayOverview()">
        <!-- Read Out Message -->
        <div
          *ngIf="
            readOut?.display &&
            !product?.summary?.properties?.has(propertiesEnum.ces)
          "
          class="pdp-summary-direct-read-out-container"
        >
          <span
            data-cy="pdp-summary-read-out-primary-text"
            [class.primary-text]="
              isDirectAllowReturnsEnabled &&
              product?.summary?.properties?.has(propertiesEnum.direct)
            "
            [class.secondary-text]="
              !isDirectAllowReturnsEnabled &&
              product?.summary?.properties?.has(propertiesEnum.direct)
            "
          >
            {{
              readOut.truncate
                ? (readOut.primaryText
                  | translate: { date: readOut.date }
                  | truncateWithEllipsis: 60)
                : (readOut.primaryText | translate: { date: readOut.date })
            }}
          </span>
          <span
            *ngIf="
              readOut.secondaryText?.length > 0 &&
              !product?.summary?.properties?.has(propertiesEnum.direct)
            "
            data-cy="pdp-summary-read-out-secondary-text"
          >
            {{ readOut.secondaryText | translate }}
          </span>

          <span
            *ngIf="
              readOut.secondaryText?.length > 0 &&
              product?.summary?.properties?.has(propertiesEnum.direct) &&
              isDirectAllowReturnsEnabled
            "
            data-cy="pdp-summary-read-out-secondary-text"
            class="secondary-text"
          >
            {{ readOut.secondaryText | translate }}
          </span>

          <span
            *ngIf="
              product?.summary?.properties?.has(propertiesEnum.direct) &&
              !isDirectAllowReturnsEnabled
            "
            data-cy="pdp-summary-read-out-secondary-text"
            class="primary-text"
          >
            {{
              'i18n.productDetail.readOut.directNoReturnsAllowedMessage'
                | translate
            }}
          </span>
        </div>
        <!-- Product Tags -->
        <div
          *ngIf="displayTags?.length > 0"
          class="pdp-summary-product-tags-container"
        >
          <app-usf-product-tag-list
            [tagList]="displayTags"
            [infoIconEnabled]="true"
            [allTagsClickable]="true"
            [product]="product"
          >
          </app-usf-product-tag-list>
        </div>
        <!-- JIT Message -->
        <div
          *ngIf="jitVendorMessage?.showMessage"
          data-cy="pdp-summary-jit-message-container"
          class="pdp-summary-jit-message-container"
          (click)="
            jitVendorMessage?.message.length > 60 && showAllAvailableStatuses()
          "
        >
          <ion-icon
            data-cy="pdp-summary-jit-message-icon"
            name="stopwatch-outline"
          ></ion-icon>
          <span data-cy="pdp-summary-jit-message-text">
            {{ jitVendorMessage?.message | truncateWithEllipsis: 65 }}
          </span>
        </div>
        <!-- CES Message -->
        <div
          *ngIf="
            readOut?.display &&
            product?.summary?.properties?.has(propertiesEnum.ces) &&
            !isGuestUser
          "
          data-cy="pdp-summary-ces-message-container"
          class="pdp-summary-ces-message-container"
        >
          <ion-icon
            data-cy="pdp-summary-ces-message-icon"
            name="stopwatch-outline"
          ></ion-icon>
          <span
            data-cy="pdp-summary-ces-message-text"
            [class.secondary-text]="!isDirectAllowReturnsEnabled"
            [class.primary-text]="isDirectAllowReturnsEnabled"
          >
            {{
              readOut.truncate
                ? (readOut.primaryText
                  | translate: { date: readOut.date }
                  | truncateWithEllipsis: 60)
                : (readOut.primaryText | translate: { date: readOut.date })
            }}
          </span>
          <span
            *ngIf="
              product?.summary?.properties?.has(propertiesEnum.direct) &&
              isDirectAllowReturnsEnabled &&
              readOut.secondaryText?.length > 0
            "
            class="secondary-text"
            data-cy="pdp-summary-ces-secondary-message-text"
          >
            {{ readOut.secondaryText | translate }}
          </span>
          <span
            *ngIf="
              product?.summary?.properties?.has(propertiesEnum.direct) &&
              !isDirectAllowReturnsEnabled
            "
            data-cy="pdp-summary-read-out-secondary-text"
            class="primary-text"
          >
            {{
              'i18n.productDetail.readOut.directNoReturnsAllowedMessage'
                | translate
            }}
          </span>
        </div>
      </ng-container>
      <!-- Divider -->
      <div
        *ngIf="
          (!isInventory ||
            !product?.summary?.properties?.has(propertiesEnum.discontinued) ||
            (!!product?.alternative &&
              product?.alternative.required &&
              !product?.alternative.available)) &&
          !isGuestUser
        "
        data-cy="pdp-summary-divider-line"
        class="horizontal-divider"
      ></div>
      <!-- Add To List Button -->
      <ng-container *ngIf="!isInventory && !isGuestUser">
        <div
          *ngIf="
            !product?.summary?.properties?.has(propertiesEnum.discontinued)
          "
          data-cy="pdp-summary-add-to-list-button-section"
          class="pdp-summary-add-to-list-container"
        >
          <ion-button
            data-cy="pdp-summary-add-to-list-button"
            class="usf-outline-green-button"
            (click)="openAddToListModal()"
          >
            <ion-icon
              data-cy="pdp-summary-add-to-list-icon"
              name="add-outline"
            ></ion-icon>
            {{ 'i18n.lists.addToList' | translate }}
          </ion-button>
        </div>
      </ng-container>
      <!-- Search for Substitutes/Replacements Button -->
      <div
        *ngIf="
          !!product?.alternative &&
          product?.alternative.required &&
          !product?.alternative.available &&
          product?.allowSearchForSubs &&
          !isGuestUser
        "
        data-cy="pdp-summary-search-alternative-buttons-section"
        class="pdp-summary-search-alts-container"
      >
        <ion-button
          *ngIf="
            productAlternativeTypes.replacement === product?.alternative?.type
          "
          data-cy="pdp-summary-search-replacements-button"
          class="usf-outline-green-button"
          (click)="searchReplacement(product?.summary, false)"
        >
          {{ 'i18n.productDetail.searchForReplacements' | translate }}
        </ion-button>
        <ion-button
          *ngIf="
            productAlternativeTypes.substitute === product?.alternative?.type
          "
          data-cy="pdp-summary-search-substitutes-button"
          class="usf-outline-green-button"
          (click)="searchReplacement(product?.summary, true)"
        >
          {{ 'i18n.productDetail.searchForSubstitutes' | translate }}
        </ion-button>
      </div>
    </div>
    <div
      *ngIf="currentTab === 1 && isGuestUser"
      data-cy="pdp-summary-login-card"
      class="pdp-summary-info-section pdp-summary-login-card"
    >
      <div>{{ 'i18n.productDetail.readyToOrder' | translate }}</div>
      <div class="guest-buttons">
        <div class="pdp-summary-learn-more-link">
          <ion-button class="usf-fill-green-button" (click)="openLearnMore()">
            {{ 'i18n.productDetail.learnMore' | translate }}
          </ion-button>
        </div>
        <div class="pdp-summary-login-button">
          <ion-button
            data-cy=""
            class="usf-outline-green-button"
            (click)="loginGuest()"
          >
            {{ 'i18n.productDetail.login' | translate }}
          </ion-button>
        </div>
      </div>
    </div>
    <app-product-detail-summary-seller-overview
      *ngIf="currentTab === 2"
      [product]="product"
      [enabledButtons]="{
        createOpportunityBtn: true,
        setCprBtn: true,
      }"
      [pricingDisabled]="pricingDisabled"
      [sellerPriceDetail]="sellerPriceDetail"
      [divisionalPromotions]="divisionalPromotions"
      (createOpportunity)="openSellerCreateAnOpportunityModal()"
      (setCPR)="openCustomPricingRationaleModal()"
    ></app-product-detail-summary-seller-overview>
  </ion-col>
</ion-row>

<ng-template #pdpSummaryTabsMobile>
  <div class="pdp-summary-tabs-mobile">
    <div *ngIf="(userType$ | async) === 'corp-ad'" class="toggle-centered">
      <app-product-detail-mode-toggle
        appTestId="pdp-summary-mode-selector"
        [isMobile]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
        "
        (selectionChanged)="toggleTab($event)"
      ></app-product-detail-mode-toggle>
    </div>

    <!-- If the favorites feature flag is OFF, we continue showing the ellipsis, otherwise we show the buttons -->
    <ng-container *appHideSplit="[favoritesFeatureFlag]">
      <div
        *ngIf="!isGuestUser"
        [ngClass]="currentTab === 2 ? 'tabs-icon-hide' : 'tabs-icon-show'"
      >
        <ng-container *appShowSplit="[shareFeatureFlag]">
          <ion-icon
            data-cy="pdp-overview-ellipsis-icon"
            name="ellipsis-vertical"
            (click)="onShareButtonPress($event)"
          ></ion-icon>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-container *appShowSplit="[favoritesFeatureFlag]">
    <div
      *ngIf="!isGuestUser"
      [ngClass]="currentTab === 2 ? 'tabs-icon-hide' : 'tabs-icon-show'"
      class="tabs-icon-show"
    >
      <ng-container *ngTemplateOutlet="actionIcons"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #pdpSummaryTabsDesktopTablet>
  <div
    [class]="'pdp-summary-tabs-desktop-tablet ' + platformService?.platformType"
  >
    <div [class.back-button-toggle]="showBackButton">
      <app-back-button
        *ngIf="showBackButton"
        [backButtonText]="'i18n.breadcrumbs.searchResults' | translate"
      ></app-back-button>
      <div *ngIf="(userType$ | async) === 'corp-ad'">
        <app-product-detail-mode-toggle
          appTestId="pdp-summary-mode-selector"
          [isMobile]="
            platformService?.platformType ===
            platformService?.platformEnum?.mobile
          "
          (selectionChanged)="toggleTab($event)"
        ></app-product-detail-mode-toggle>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="actionIcons"></ng-container>
  </div>
</ng-template>

<ng-template #actionIcons>
  <div
    [class]="'tabs-icons ' + platformService.platformType"
    *ngIf="!isGuestUser"
    [ngClass]="currentTab === 2 ? 'tabs-icon-hide' : 'tabs-icon-show'"
  >
    <ng-container *appShowSplit="[favoritesFeatureFlag]">
      <div class="tabs-icons-favorites" (click)="onAddToFavoritesButtonPress()">
        <ion-icon [name]="isFavorite ? 'heart' : 'heart-outline'"> </ion-icon>
        <span class="favorites-text">
          {{ 'i18n.common.addToFavorites' | translate }}
        </span>
      </div>
    </ng-container>
    <ng-container *appShowSplit="[printFeatureFlag]">
      <div class="tabs-icons-print" (click)="onPrintButtonPress()">
        <ion-icon name="print-outline"> </ion-icon>
        <span class="print-text">
          {{ 'i18n.common.print' | translate }}
        </span>
      </div>
    </ng-container>
    <ng-container
      *appShowSplit="[
        platformService.platformType === platformService.platformEnum.desktop
          ? shareDesktopFeatureFlag
          : shareFeatureFlag,
      ]"
    >
      <div class="tabs-icons-share" (click)="onShareButtonPress($event, false)">
        <ion-icon data-cy="pdp-overview-share-icon" name="share-social-outline">
        </ion-icon>
        <span class="share-text">
          {{ 'i18n.common.share' | translate }}
        </span>
      </div>
    </ng-container>
  </div>
</ng-template>
